// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__D0XFl","content":"styles_content__J65R4"};